import React from "react"
import { Layout } from "../components/baselayout"
import { WhiteDiv } from "../components/whitediv"
import { Email } from "../components/email"
import { Link } from "gatsby"

const ContactUs: React.FC = () => (
  <Layout title="Contact Us">
    <WhiteDiv>
      <h1>Contact Us</h1>
      <hr />
      <p>
        General Enquiries: <Email address="head.scientist@cugcr.org.uk" /> or{" "}
        <Email address="secretary@cugcr.org.uk" />
      </p>
      <p>
        Training: <Email address="training@cugcr.org.uk" />
      </p>
      <p>
        For email addresses of other committee members, please see the{" "}
        <Link to="/about">About our Research</Link> page.
      </p>
    </WhiteDiv>
  </Layout>
)

export default ContactUs
